import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import {
    type ResellSuggestionsApiResponse,
    type ResellSuggestionsRequest,
} from 'tradera/state/services/types/webapi-mytradera-generated';
import qs from 'qs';

export const resellSuggestionsApi = createApi({
    reducerPath: 'resellSuggestionsApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getResellSuggestions: builder.query<
            ResellSuggestionsApiResponse,
            ResellSuggestionsRequest
        >({
            query: (params) =>
                `/mytradera/web/resell-suggestions?${qs.stringify(params)}`,
        }),
    }),
});

export const { useGetResellSuggestionsQuery } = resellSuggestionsApi;
